import { ReactElement } from 'react'

import { WithContext, BlogPosting, FAQPage } from 'schema-dts'

import { SETTINGS_GENERAL } from '@/config/settings.general'
import { CONTENT_LOCALE_CONFIG } from '@/i18n/contentLocales'

import type { ContentLocale } from '@/i18n/contentLocales'
import type { FaqItem } from '@/lib/blogFaq'

interface Props {
    title: string
    description?: string
    image: string
    createdAt: string
    updatedAt: string
    locale: ContentLocale
    url: string
    /** Пары вопрос-ответ из раздела «Частые вопросы» → FAQPage (≥2, иначе разметку не выводим) */
    faq?: FaqItem[]
}

export default function ArticleGoogleSchema({
    title,
    description,
    image,
    createdAt,
    updatedAt,
    locale,
    url,
    faq = [],
}: Props): ReactElement {
    const scheme: WithContext<BlogPosting> = {
        '@context': 'https://schema.org',
        '@type': 'BlogPosting',
        headline: title,
        description,
        image,
        inLanguage: CONTENT_LOCALE_CONFIG[locale].htmlLang,
        datePublished: createdAt,
        dateModified: updatedAt,
        mainEntityOfPage: url,
        author: [
            {
                '@type': 'Organization',
                name: 'BukaGo',
                url: SETTINGS_GENERAL.SITE_URL,
            },
        ],
    }

    const faqScheme: WithContext<FAQPage> | null =
        faq.length >= 2
            ? {
                  '@context': 'https://schema.org',
                  '@type': 'FAQPage',
                  inLanguage: CONTENT_LOCALE_CONFIG[locale].htmlLang,
                  mainEntity: faq.map(item => ({
                      '@type': 'Question',
                      name: item.question,
                      acceptedAnswer: { '@type': 'Answer', text: item.answer },
                  })),
              }
            : null

    return (
        <>
            <script
                type={'application/ld+json'}
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify(scheme),
                }}
            />
            {faqScheme ? (
                <script
                    type={'application/ld+json'}
                    dangerouslySetInnerHTML={{
                        __html: JSON.stringify(faqScheme),
                    }}
                />
            ) : null}
        </>
    )
}
